import { render } from "./companypass.vue?vue&type=template&id=696faa4c&scoped=true"
import script from "./companypass.vue?vue&type=script&lang=js"
export * from "./companypass.vue?vue&type=script&lang=js"

import "./companypass.vue?vue&type=style&index=0&id=696faa4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-696faa4c"

export default script